/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import Thumbor from '@common_image';
import Typography from '@common/Typography';
import cx from 'classnames';
import Select from '@common/Forms/Select';

const StoreList = ({
    //
    storeList,
    onClickListItem,
    t,
    storeIndex = null,
    storeUrlKey,
}) => {
    const stateList = storeList.map((item) => item.state);
    const filteredState = stateList.filter((value, index) => stateList.indexOf(value) === index);
    const stateOptions = filteredState.map((state) => {
        return {
            label: state,
            value: state,
        };
    });

    const [province, setProvince] = useState('');
    const [stores, setStores] = useState(storeList);

    const handleChange = (value) => {
        const newItem = storeList.filter(
            ({
                state,
            }) => state.toLowerCase().search(value.toLowerCase()) > -1,
        );
        setProvince(value);
        setStores(newItem);
    };

    const [activeStore, setActiveStore] = useState(storeIndex);

    const scrollToOverflowElement = (targetElementId) => {
        const targetElement = document.getElementById(targetElementId);
        const parent = targetElement.parentElement.parentElement;

        // Calculate the offset from target element to top of parent.
        const { offsetTop } = targetElement;
        const parentScrollTop = parent.scrollTop + 240;
        // Scroll the parent element to make the overflowing element visible.
        parent.scroll({
            top: offsetTop - parentScrollTop,
            behavior: 'smooth', // Optional for smooth scrolling
        });
    };

    React.useEffect(() => {
        if (storeUrlKey) {
            scrollToOverflowElement(storeUrlKey);
        }
    }, []);

    return (
        <>
            <Select
                className={cx('select-state', 'mb-5', 'max-w-fit')}
                classNameLabel={cx('!capitalize')}
                options={[
                    { label: 'Provinsi', value: '' },
                    ...stateOptions,
                ]}
                placeholder="Provinsi"
                name="province"
                value={province}
                onChange={(val) => {
                    handleChange(val);
                }}
                textFiledProps={{
                    floatLabel: false,
                    className: 'w-fit',
                }}
                inputProps={{
                    className: '!text-[13px]',
                }}
            />
            <div className="store-list">
                <div className="py-2">
                    {stores.map((store, i) => (
                        <div key={i} id={store.rewrite_request_path}>
                            <div
                                className={cx(
                                    'flex',
                                    'py-[15px]',
                                    'px-2',
                                    'mb-4',
                                    'hover:bg-primary-50',
                                    'cursor-pointer',
                                    'transition-[background-color_150ms_cubic-bezier(0.4,0,0.2,1)_0ms]',
                                    { 'bg-primary-50': activeStore === i },
                                )}
                                onClick={() => {
                                    onClickListItem(store);
                                    setActiveStore(i);
                                }}
                            >
                                <div className="w-[20px] mx-2">
                                    {
                                        activeStore === i && (
                                            <CheckCircleIcon className="h-[20px] w-[20px] mt-1 text-neutral-black" />
                                        )
                                    }
                                </div>
                                {
                                    store.baseimage && (
                                        <div className="min-w-[56px] h-10 mt-2">
                                            <div className="rounded-[50%] w-10 h-10 overflow-hidden">
                                                <Thumbor src={store.baseimage} width={40} height={40} />
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="flex flex-col flex-1">
                                    <div>
                                        <Typography
                                            color="text-neutral-black"
                                            className={cx('text-base !font-bold')}
                                        >
                                            {store.store_name}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography
                                            color="text-neutral-black"
                                            className={cx('text-sm leading-none !font-normal')}
                                        >
                                            {t('storelocator:address')}
                                            :
                                            {' '}
                                            {store.address}
                                            <br />
                                            {t('storelocator:state')}
                                            :
                                            {' '}
                                            {store.state}
                                            <br />
                                            {t('storelocator:city')}
                                            {' '}
                                            {store.city}
                                            {', '}
                                            {store.zipcode}
                                            <br />
                                            { store.phone }
                                        </Typography>
                                        <div>
                                            <a
                                                className="direction-button"
                                                href={`https://www.google.com/maps/dir/Current+Location/${store.lat},${store.lng}`}
                                                rel="noreferrer"
                                                target="_blank"
                                            >
                                                {t('storelocator:direction')}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {!storeList.length && <div>No Results.</div>}
            </div>
            <style jsx>
                {`
                    .store-list {
                        height: calc(50vh + 72px);
                        max-height: calc(50vh + 72px);
                        margin-bottom: 16px;
                        overflow: auto;
                        scrollbar-width: thin;
                        scrollbar-color: #ebebeb transparent;
                    }
                    @media screen and (max-width: 767px) {
                        .store-list {
                            height: unset;
                        }
                    }
                    h3 {
                        margin: 0;
                    }
                    h3 span {
                        float: right;
                    }
                    hr {
                        border: 0;
                        border-top: 2px solid #ddd;
                    }
                    .direction-button {
                        float: right;
                        font-weight: bold;
                        font-size: 12px;
                    }
                    .direction-button:hover {
                        text-decoration: underline;
                    }
                `}
            </style>
        </>
    );
};

export default StoreList;
